<template>
  <div class="table-row">
    <div v-if="tipo === 'mese'" :class="[giorno.festivo === 'SI' ? 'festivi' : '', 'element']" style="width: 70px">
      {{ giorno.sigla.substring(0, 3) }} {{ giorno.num }}
    </div>
    <div style="width: 70px" class="element">
      <v-select v-model="giorno.ore" :options="orario" label="descrizione" :clearable="false"
        :disabled="isDisabled(giorno)"></v-select>

    </div>
    <div :style="{ 'width': widthSelect + 'px' }" class="widthSelect">
      <div style="width: 19%" class="element">
        <v-select v-model="giorno.causale" :options="causali" label="descrizione" :clearable="false"
          :disabled="isDisabled(giorno)" direction="top"></v-select>
      </div>

      <!--<div v-if="isDisabled(giorno)" style="width: 19%" class="element">
        <el-input class="disabled" :disabled="true"
                  :value="giorno.multiriga === 'NO' ? getDesLoc(giorno,giorno.localita) : '---'"></el-input>
      </div>-->
      <div style="width: 19%" class="element">
        <el-input v-if="showLocCustom(giorno)" v-model="giorno.descrLoc" :disabled="isDisabled(giorno)">
          <i slot="prepend" @click="clearLoc(giorno, 'G')" class="el-icon-arrow-left"></i>
        </el-input>
        <v-select v-else v-model="giorno.localita" :options="località" label="descrizione" :clearable="false"
          :disabled="isDisabled(giorno)"></v-select>
      </div>
      <div style="width: 19%" class="element">
        <el-input v-if="giorno.edit === false" class="disabled" :disabled="true"
          :value="giorno.multiriga === 'NO' ? getDesCausale(giorno.causale) : '---'"></el-input>
        <v-select v-else v-model="giorno.azienda" :options="aziende" label="descrizione" :clearable="false"
          :disabled="isDisabled(giorno)"></v-select>
      </div>
      <div style="width: 19%" class="element">
        <el-input v-if="giorno.edit === false" class="disabled" :disabled="true"
          :value="giorno.multiriga === 'NO' ? getDesCausale(giorno.causale) : '---'"></el-input>
        <v-select v-else v-model="giorno.cdc"
          :options="giorno.azienda !== null ? aziende[mapAzi[giorno.azienda.valore]].cdc : []" label="valDesc"
          :clearable="false" :disabled="isDisabled(giorno)"></v-select>
      </div>
      <div style="width: 20%" class="element">
        <!-- <el-input v-model="giorno.intervento" :disabled="isDisabled(giorno)"></el-input> -->
        <input v-model="giorno.intervento" :disabled="isDisabled(giorno)" />
      </div>
    </div>

    <div v-if="tipo !== 'AttPred' && auto === 'SI'" style="width: 70px" class="element">
      <input v-model.number="giorno.km" :disabled="isDisabled(giorno)" type="number"></input>
      <!--<el-input-number v-model="giorno.km" :disabled="isDisabled(giorno)" :min="0" :controls="false"></el-input-number>-->
    </div>


    <div v-if="tipo === 'mese'" style="width: 190px" data-col="action" class="element">
      <div class="element action_icon">
        <el-tooltip class="item" effect="dark" :content="$t('presenza.salvato')" placement="top-start"
          :open-delay="1000">
          <icon
            v-if="(giorno.compilato === 'SI' && rowDay.errorDays[giorno.num] !== true) || rowDay.savedDays[giorno.num] === true"
            name="riv-tick" scale="1.3"></icon>
        </el-tooltip>
        <icon v-if="rowDay.errorDays[giorno.num] === true" name="elm-chiudi" scale="1.3"></icon>
        <!--<img v-if="giorno.edit === false" class="pointer" src="../images/edit.png">-->
        <!--<img v-if="giorno.edit === true" class="pointer" src="../images/edit_selezionato.png">-->
      </div>
      <div class="element action_icon" @click.prevent.stop="pulisciGiorno(giorno)">
        <el-tooltip class="item" effect="dark" :content="$t('presenza.pulisci')" placement="top-start"
          :open-delay="1000">
          <icon name="riv-delete2" scale="1.3"></icon>
        </el-tooltip>
      </div>
      <div class="element action_icon" @click.prevent.stop="sitGiorno(giorno)">
        <el-tooltip class="item" effect="dark" :content="$t('presenza.detGio')" placement="top-start"
          :open-delay="1000">
          <icon name="riv-calendario" :class="giorno.multiriga === 'SI' && giorno.compilato === 'SI' ? 'compilato' : ''"
            scale="1.3"></icon>
        </el-tooltip>
      </div>
      <div class="element action_icon" @click.prevent.stop="checkCopia(giorno, indexGiorno)">
        <el-tooltip class="item" effect="dark" :content="$t('presenza.copia')" placement="top-start" :open-delay="1000">
          <icon name="riv-copy" :class="rowDay.giornoCopia.indexCheckCopia === indexGiorno ? 'compilato' : ''"
            scale="1.3"></icon>
        </el-tooltip>
      </div>
      <div class="element action_icon" @click.prevent.stop="incollaGiorno(giorno)">
        <el-tooltip class="item" effect="dark" :content="$t('presenza.incolla')" placement="top-start"
          :open-delay="1000">
          <icon name="riv-paste" scale="1.3"></icon>
        </el-tooltip>
      </div>
    </div>

    <div v-else style="width: 4%" data-col="action" class="element">
      <div class="element action_icon" @click.prevent.stop="pulisciGiorno(giorno)">
        <icon name="riv-delete2" scale="1.3"></icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowDay',
  props: ['activateWatch', 'giorno', 'indexGiorno', 'causali', 'località', 'aziende', 'mapAzi', 'orario', 'auto', 'rowDay', 'tipo', 'widthSelect', 'chiuso'],
  i18n: {
    messages: {
      it_IT: {
        presenza: {
          salvato: 'Giorno Salvato',
          pulisci: 'Pulisci Giorno',
          detGio: 'Visualizza Dettaglio Giornaliero',
          copia: 'Copia Giorno',
          incolla: 'Incolla Giorno'
        }
      },
      en_GB: {
        presenza: {
          salvato: 'Day Saved',
          pulisci: 'Clean Day',
          detGio: 'View Daily Detail',
          copia: 'Copy Day',
          incolla: 'Paste Day'
        }
      },
      es_ES: {
        presenza: {
          salvato: 'Día guardado',
          pulisci: 'Día limpio',
          detGio: 'Ver detalles diarios',
          copia: 'Día de la copia',
          incolla: 'Pegar día'
        }
      },
      fr_FR: {
        presenza: {
          salvato: 'Jour enregistré',
          pulisci: 'Journée propre',
          detGio: 'Voir les détails quotidiens',
          copia: 'Jour de copie',
          incolla: 'Coller le jour'
        }
      },
      de_DE: {
        presenza: {
          salvato: 'Tag gespeichert',
          pulisci: 'Sauberer Tag',
          detGio: 'Tägliche Details anzeigen',
          copia: 'Tag kopieren',
          incolla: 'Tag einfügen'
        }
      }
    }
  },
  data: function () {
    return {
      label: 'descrizione',
      oreUnWatch: null,
      causaleUnWatch: null,
      localitaUnWatch: null,
      aziendaUnWatch: null,
      cdcUnWatch: null,
      attUnWatch: null,
      kmUnWatch: null
    }
  },
  methods: {
    changeAzienda: function (giorno) {
      this.$emit('changeAzienda', giorno)
    },
    editGiorno: function (giorno, index) {
      this.$emit('editGiorno', giorno, index)
    },
    pulisciGiorno: function (giorno) {
      this.$emit('pulisciGiorno', giorno)
    },
    checkCopia: function (giorno, index) {
      this.$emit('checkCopia', giorno, index)
    },
    incollaGiorno: function (giorno) {
      this.$emit('incollaGiorno', giorno)
    },
    sitGiorno: function (giorno) {
      this.$emit('sitGiorno', giorno)
    },
    isDisabled: function (giorno) {
      if (this.chiuso === 'SI') {
        return true
      } else if (giorno.edit === false) {
        return true
      } else if (giorno.ifBloc === 'SI' || giorno.multiriga === 'SI') {
        return true
      } else {
        return false
      }
    },
    clearLoc: function (giorno, type) {
      if (!this.isDisabled(giorno)) {
        if (type === 'G') {
          giorno.descrLoc = ''
          giorno.localita = null
        } else {
          giorno.descrLoc = ''
          giorno.localita = null
        }
      }
    },
    showLocCustom: function (giorno) {
      if (giorno.localita === null) {
        return false
      } else if (giorno.localita.valore === 'E98' || giorno.localita.valore === 'E99') {
        return true
      } else {
        return false
      }
    },
    getDesLoc: function (giorno, codLoc) {
      if (giorno.localita === 'E98' || giorno.localita === 'E99') {
        return giorno.descrLoc
      } else {
        giorno.localita === 'E98' || giorno.localita === 'E99'
        for (let i = 0; i < this.località.length; i++) {
          if (this.località[i].valore === codLoc) return this.località[i].descrizione
        }
        return ''
      }
    },
    initializedWatch: function () {
      if (this.giorno.azienda !== null && this.giorno.azienda.valore !== null) {
        this.$emit('changeAzienda', this.giorno.azienda.valore)
      }
      this.$watch('giorno.activateWatch', function (newVal, oldVal) {
        if (newVal) {
          if (this.oreUnWatch !== null) this.oreUnWatch()
          if (this.causaleUnWatch !== null) this.causaleUnWatch()
          if (this.localitaUnWatch !== null) this.localitaUnWatch()
          if (this.aziendaUnWatch !== null) this.aziendaUnWatch()
          if (this.cdcUnWatch !== null) this.cdcUnWatch()
          if (this.attUnWatch !== null) this.attUnWatch()
          if (this.kmUnWatch !== null) this.kmUnWatch()
          if (this.giorno.azienda !== null && this.giorno.azienda.valore !== null) {
            this.$emit('changeAzienda', this.giorno.azienda.valore)
          }
          this.oreUnWatch = this.$watch('giorno.ore', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, '')
          })
          this.causaleUnWatch = this.$watch('giorno.causale', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, 'causale')
          })
          this.localitaUnWatch = this.$watch('giorno.localita', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, 'localita')
          })
          this.aziendaUnWatch = this.$watch('giorno.azienda', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, 'azienda')
            this.$emit('changeAzienda', newValue.valore)
            this.giorno.cdc = null
          })
          this.cdcUnWatch = this.$watch('giorno.cdc', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, 'cdc')
          })
          this.attUnWatch = this.$watch('giorno.intervento', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, 'intervento')
          })
          this.kmUnWatch = this.$watch('giorno.km', function (newValue, oldValue) {
            this.$emit('setToSave', this.giorno, 'km')
          })
          this.giorno.activateWatch = false
        }
      })
      this.oreUnWatch = this.$watch('giorno.ore', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, '')
      })
      this.causaleUnWatch = this.$watch('giorno.causale', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, 'causale')
      })
      this.localitaUnWatch = this.$watch('giorno.localita', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, 'localita')
      })
      this.aziendaUnWatch = this.$watch('giorno.azienda', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, 'azienda')
        this.$emit('changeAzienda', newValue.valore)
        this.giorno.cdc = null
      })
      this.cdcUnWatch = this.$watch('giorno.cdc', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, 'cdc')
      })
      this.attUnWatch = this.$watch('giorno.intervento', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, 'intervento')
      })
      this.kmUnWatch = this.$watch('giorno.km', function (newValue, oldValue) {
        this.$emit('setToSave', this.giorno, 'km')
      })
      this.giorno.activateWatch = false
    }
    /*getCdc: function (giorno) {
     console.log("getCdcRow"+giorno.azienda)
     if (giorno.azienda !== null) {
     return this.aziende[this.mapAzi[giorno.azienda.valore]].cdc
     }
     }*/
  },
  mounted: function () {
    this.initializedWatch()
  },
  activated: function () {
    this.initializedWatch()
  },
  deactivated: function () {
    if (this.oreUnWatch !== null) this.oreUnWatch()
    if (this.causaleUnWatch !== null) this.causaleUnWatch()
    if (this.localitaUnWatch !== null) this.localitaUnWatch()
    if (this.aziendaUnWatch !== null) this.aziendaUnWatch()
    if (this.cdcUnWatch !== null) this.cdcUnWatch()
    if (this.attUnWatch !== null) this.attUnWatch()
    if (this.kmUnWatch !== null) this.kmUnWatch()
  },
  destroyed: function () {
    this.$destroy()
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.table-row {
  font-size: 13px !important;
  // height: 45px;
  line-height: 35px;
  border-bottom: 1px solid #ebeef5;

  .widthSelect {
    display: inline-block;
  }

  .element {
    vertical-align: middle;
    display: inline-block;
    line-height: 35px;
    text-align: center;
    color: #000 !important;
  }

  .festivi {
    background-color: @oroRiva;
    opacity: 0.8;
    color: white;
  }

  input {
    background: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    height: 43px;
    width: 98%;

    &:disabled {
      background-color: #f8f8f8;
    }
  }

  .v-select {
    .selected-tag {
      //font-size: 10px;
    }

    .dropdown-toggle {
      display: flex !important;
      //flex-wrap: wrap;
    }

    .dropdown-toggle::after {
      display: none;
    }

    .dropdown-menu {
      font-size: 12px; // font list
      //flex-wrap: wrap;
    }
  }

  .v-select input[type=search],
  .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 33px;
    padding: 0 20px 0 10px;
    width: 100% !important;
    font-size: 12px !important;
  }

  .v-select {
    .selected-tag {
      //font-size: 8px !important;
      text-align: left;
      position: absolute;

      //white-space: nowrap;
      //overflow: hidden;
      .close {
        font-size: 8px !important;
      }
    }
  }

  .el-input-number {
    width: 100%;
    font-size: 13px !important;
  }

  .el-input {
    width: 100%;
    font-size: 13px !important;

    .el-input__inner {
      height: 43px;
      padding-left: 2px;
      padding-right: 2px;
    }
  }

  /*.disabled {
      input {
        color: black !important;
        font-size: 13px !important;
        padding-left: 2px; //7px;
        padding-right: 2px;
        text-align: center;
      }
    }*/
  .action_icon {
    width: 35px;

    .fa-icon {
      cursor: pointer;
    }

    .compilato {
      color: #ef7f01;
    }
  }
}

.riv-tick-c0 {
  fill: green;
}

.elm-chiudi-c0 {
  fill: red;
}
</style>



// WEBPACK FOOTER //
// src/components/PresenzeWeb/RowDay.vue